import { render, staticRenderFns } from "./UploadVedio.vue?vue&type=template&id=467cce02&scoped=true"
import script from "./UploadVedio.vue?vue&type=script&lang=js"
export * from "./UploadVedio.vue?vue&type=script&lang=js"
import style0 from "./UploadVedio.vue?vue&type=style&index=0&id=467cce02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cce02",
  null
  
)

export default component.exports